interface IConfig {
  nodeEnv: string;
  apiUrl: string;
  apiPrefix: string;
  appDeepLinkUrl: string;
  amplitudeApiKey: string;
  iosStoreLink: string;
  androidStoreLink: string;
  clarityProjectId: string;
  oneLinkUrl: string;
}

declare global {
  interface Window {
    APP_CONFIG: IConfig;
  }
}

export default window.APP_CONFIG;
